(function(){
  try {
    var q = new URLSearchParams(location.search), p = [];
    var pagado = q.get('utm_source') || q.get('gclid') || q.get('fbclid');
    if (sessionStorage.getItem('bs_origen1') && !pagado) return;
    ['utm_source','utm_medium','utm_campaign'].forEach(function(k){ if(q.get(k)) p.push(q.get(k)); });
    if(q.get('gclid')) p.push('gclid');
    if(q.get('fbclid')) p.push('fbclid');
    var ref = document.referrer ? new URL(document.referrer).hostname : '';
    if(ref && ref.indexOf('bigstudio.cl') === -1) p.push('ref ' + ref);
    if (p.length) sessionStorage.setItem('bs_origen1', p.join(' / '));
  } catch(err){}
})();

(function(){
  if(location.pathname.indexOf('/pages/agenda') === 0) return;
  function rw(){
    var as = document.querySelectorAll('a[href*="calendly.com"]');
    for(var i=0;i<as.length;i++){ as[i].setAttribute('href','/pages/agenda?origen=' + (location.pathname.replace(/^\/(pages\/)?/,'').replace(/\//g,'-') || 'home') + '-js'); as[i].removeAttribute('target'); }
  }
  if(document.readyState !== 'loading'){ rw(); } else { document.addEventListener('DOMContentLoaded', rw); }
  document.addEventListener('shopify:section:load', rw);
})();


(function () {
  'use strict';

  var PIXEL_ID = '595968475232736';

  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
  (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');

  if(!window.bsMetaAgendaInicializado){ fbq('init', PIXEL_ID); window.bsMetaAgendaInicializado = true; }

  var SELECTOR = '.bs-wa, .js-wa, a[href*="wa.me"], a[href*="api.whatsapp.com"]';

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest(SELECTOR)) return;

    var datos = {
      content_name: location.pathname,
      content_category: 'WhatsApp'
    };
    var plan = document.querySelector('.bs-agf__plan.is-sel');
    if (plan) {
      datos.content_name = plan.getAttribute('data-name') || location.pathname;
      datos.content_category = 'WhatsApp Agenda';
      var clpEl = document.querySelector('.bs-agf__price-clp');
      if (clpEl) {
        datos.value = Number(clpEl.dataset.valorClp || 0); datos.currency = 'CLP';
      }
    }

    fbq('track', 'Contact', datos);
  }, true);

})();
